import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  transactionNotesService,
  TransactionNote,
  CreateTransactionNoteRequest,
} from '@aslanpay/portal-common-lib';

const useCreateTransactionNote = ({
  onSuccess,
  onError,
}: UseMutationOptions<TransactionNote, Error, CreateTransactionNoteRequest>) => {
  return useMutation<TransactionNote, Error, CreateTransactionNoteRequest>(
    ({ transactionIds, note }: CreateTransactionNoteRequest) =>
      transactionNotesService.createTransactionNote({
        transactionIds,
        note,
      }),
    { onSuccess, onError }
  );
};

export default useCreateTransactionNote;
